/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
(function($) {

  // all external links should open in a new tab
  document.querySelectorAll(`a[href^="http"]:not([href*="${window.location.hostname}"])`).forEach(t=>t.setAttribute("target","_blank"));
  
  if ($('.PageHeader.PageHeader--withBackground').length) {
    $('.CollectionInner').addClass('hasHeaderImage');
  }

  $(".regular").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    speed: 700,
    arrows: false,
    cssEase: 'linear'
  });

  $(".royalSlider").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    fade: true,
    speed: 700,
    arrows: true,
    cssEase: 'linear'
  });

  $(window).scroll(function() {
    var scroll = $(window).scrollTop();

    if (scroll >= 500) {
      $(".buy-bar").addClass("active");
    } else {
      $(".buy-bar").removeClass("active");
    }
  });

  // shim for browsers that don't support dataset
  var getData = function(elt, key) {
    if('dataset' in elt) {
      return elt.dataset[key];
    }
    else {
      return elt.getAttribute(['data', key].join('-'));
    }
  }

  var Zoomper = function(elt, small, large) {
    this.elt = elt;
    this.smallImg = small;
    this.largeImg = large;
    this.frameSize = {'width': parseInt(elt.style.width), 'height': parseInt(elt.style.height)};
    this.mode = 'out';
    this.cursorStates = {'in': 'zoom-out', 'out': 'zoom-in'};
    this.largeLoaded = false;
  }
  Zoomper.prototype = {
    positionZoom: function(evt) {
      var diff = {'x': evt.offsetX / this.frameSize.width, 'y': evt.offsetY / this.frameSize.height};
      this.elt.style.backgroundPosition = [diff.x * 100, '%', ' ', diff.y * 100, '%'].join('');
    },
    listenHover: function() {
      var _this = this;
      this.elt.addEventListener('mousemove', function(evt) {
        if(_this.mode === 'out') return;
        _this.positionZoom(evt);
      });
    },
    unlistenHover: function() {
      this.elt.style.backgroundPosition = 'center center';
      // this.elt.removeEventListener('mousemove'); line 28 instead
    },
    zoomState: function(mode) { // 'in' || 'out'
      if(mode === 'in') {
        this.elt.style.backgroundImage = 'url(' + this.largeImg + ')';
        this.listenHover();
        this.elt.style.cursor = this.cursorStates.in;
      }
      else {
        this.elt.style.backgroundImage = 'url(' + this.smallImg + ')';
        this.unlistenHover();
        this.elt.style.cursor = this.cursorStates.out;
      }
    },
    zoomStateToggle: function() {
      this.mode = this.mode === 'in' ? 'out' : 'in';
      this.zoomState(this.mode);
    },
    loadImagesCB: function(toLoad, cb) {
      var loaded = 0,
          checkComplete = function() {
            loaded++;
            if(toLoad.length === loaded) cb();
          }
      for(var i = 0; i < toLoad.length; i++) {
        var img = new Image;
        img.onload = checkComplete;
        img.src = toLoad[i];
      }
    },
    loadState: function(loading) {
      if(loading) this.loadElt.style.display = 'block';
      else this.loadElt.style.display = 'none';
    },
    clickHandler: function(evt) {
      var _this = this;
      // show zoom immediately
      if(_this.largeLoaded) {
        _this.zoomStateToggle();
        _this.positionZoom(evt);
      }
      // show loading state while zoom image loads
      else {
        _this.loadState(true);
        _this.loadImagesCB([_this.largeImg], function() {
          _this.largeLoaded = true;
          _this.clickHandler(evt);
          _this.loadState(false);
        });
      }
    },
    init: function() {
      var _this = this;
      _this.elt.style.backgroundRepeat = 'no-repeat';
      _this.elt.style.position = 'relative';
      _this.zoomState('out');
      _this.elt.addEventListener('click', function(evt) { _this.clickHandler(evt); });
      _this.loadElt = document.createElement('div');
      _this.loadElt.style.cssText = 'display:none;height:100%;width:100%;top:0;left:0;position:absolute;background:rgba(255,255,255,.6);';
      _this.loadElt.innerHTML = '<div style="height:100%;width:100%;top:0;left:0;position:absolute;background: url(\'data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==\') center center no-repeat;"></div>';
      _this.elt.appendChild(_this.loadElt);
      return _this;
    }
  }

  var zoomper = function(elt) {
    return new Zoomper(elt, getData(elt, 'small'), getData(elt, 'large')).init();
  }

  $.fn.zoomper = function() { return this.each(function() { zoomper(this); }); }


  $('.search_icon').on('click', function(e){
    e.preventDefault();
    if ($('#shopify-section-header .Search').attr('aria-hidden') == 'false') {
      $('#shopify-section-header .Search').attr('aria-hidden', 'true');
    } else {
      $('#shopify-section-header .Search').attr('aria-hidden', 'false');
      $('header.Header').removeClass('Header--transparent');
      setTimeout(function() {
        $('#shopify-section-header .Search__Input').focus();
      }, 500);
    }
  });

  $('#Search .Search__Close').on('click', function(){
    $('a[data-action="toggle-search"]').trigger('click');
  });

  $(document).on('click', function(e){
    var pSec = $(e.target).parents('section').attr('class');
	var but = $(e.target).attr('data-drawer-id');
    if(but == 'sidebar-menu'){

    }else{
      if($('#sidebar-menu').attr('aria-hidden') == "false" && pSec == undefined){
        $('#sidebar-menu').find('.Drawer__Close').trigger('click');
      }
    }

  });

  $(document).on('click', '.yotpo-display-wrapper', function(){
    $('.pro_tab .tab .tablinks').eq(1).trigger('click');
  });

  $(".mobile_search .search_ic").click(function(){
    $("#Search").fadeIn();
    $("#Search").attr("aria-hidden", "false");
      $('header.Header').removeClass('Header--transparent');
  });

  $(".closepopup18").click(function(){
    $(".blockUI.blockOverlay").fadeTo("slow", 0);
    $(".elementclose18").remove();
  });


  $(document).on('click', '#collection-sort-popover .Popover__Content button', function(){
    if($(window).innerWidth() <= 991) {


//       var obj = $('#collection-sort-popover');
//       obj.attr("aria-hidden","true");
//       obj.removeAttr("tabindex");
//       $('html').removeClass('no-scroll');

    }
  });

  $(document).on('click', '#collection-sort-popover .Popover__Close', function(){
    if($(window).innerWidth() <= 991) {


//       var obj = $('#collection-sort-popover');
//       obj.attr("aria-hidden","true");
//       obj.removeAttr("tabindex");
//       $('html').removeClass('no-scroll');

    }
  });


  // load after 8s
  $(function(){
    var recently = $("#shopify-section-recently-viewed-products");
    recently.addClass("force-hide");

    setTimeout(function(){ recently.removeClass("force-hide"); }, 5000);

  });


  // get confirmation from url
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
  };

  function updateAnnouncement(text, color){
    var elm = $('#section-announcement .AnnouncementBar');
  	var textTarget = $('#section-announcement .Heading a');
    var textBefore = textTarget.text();


    textTarget.text(text);
    elm.addClass(color);

    setTimeout(
      function()
      {
        //reset
        textTarget.text(textBefore);
        elm.removeClass(color);
      }, 10000);

  }

  var customer_posted = getUrlParameter('customer_posted');
  var form_type = getUrlParameter('form_type');
  var contactTags = getUrlParameter('contact%5Btags%5D');

  //console.log(customer_posted,form_type,contactTags );

  if (form_type == 'customer' && contactTags == 'newsletter'){
  	updateAnnouncement('You had already on the list of subscription, You don\'t have to subscribe again','Alert--error')
  }


  if (customer_posted == 'true'){
  	updateAnnouncement('Success, You have been subscribed to our newsletter.','Alert--success')
  }

  /* Purchase Limit code */
  var addToCartForm = $('form[action^="/cart/add"]');
  function pdp_checkPurchaseLimit(variantId, qtyAdded) {
    //var productId = addToCartForm.attr('id').replace('product_form_');
    //var sameProductInCart = $('.CartItem[data-productid="' + productId + '"]');
    
    if (typeof variantId == 'undefined')
      variantId = addToCartForm.find('[name="id"]').val();
    
    var qtyInput = addToCartForm.find('[name="quantity"]');
    var maxqty = qtyInput.data('max');
    if (maxqty && !isNaN(maxqty)) {
      maxqty = parseInt(maxqty);

      var sameVariantInCart = $('.CartItem[data-variantid="' + variantId + '"]');
      if (sameVariantInCart.length) {
        //console.log('same variant in cart', variantId);
        var qtyInCart = parseInt(sameVariantInCart.find('.QuantitySelector__CurrentQuantity').val());
        if (typeof qtyAdded !== 'undefined') {
          qtyInCart = qtyInCart + qtyAdded;
        }
        qtyInput.attr('data-qtyincart', qtyInCart).next('.QuantitySelector__Button').attr('data-qtyincart', qtyInCart);
        if (qtyInCart >= maxqty) {
          	//console.log('disable add to cart');
        	addToCartForm.find('button[type="submit"]').prop('disabled', true).addClass('Button--secondary').removeClass('Button--primary').find('span').text(maxqty + ' per customer');
        }
      } else {
        //console.log('variant not in cart');
        
        if (typeof qtyAdded !== 'undefined') {
          var qtyInCart = parseInt(qtyAdded);
          qtyInput.attr('data-qtyincart', qtyInCart).next('.QuantitySelector__Button').attr('data-qtyincart', qtyInCart);
          if (qtyInCart >= maxqty) {
          	//console.log('disable add to cart');
        	addToCartForm.find('button[type="submit"]').prop('disabled', true).addClass('Button--secondary').removeClass('Button--primary').find('span').text(maxqty + ' per customer');
          } else {
            //console.log('qtyAdded ' + qtyAdded + ' does not exceed maxqty ' + maxqty);
          }
        } else {
			//console.log('qtyAdded not passed to function');
        }
        
      }
    } else {
      //console.log('no max qty set');
    } 
  }


  // check purchase limit on page load
  if (addToCartForm.length) {
  	pdp_checkPurchaseLimit();
  }
  // check purchase limit on variant changed
  document.addEventListener('variant:changed', function(event) {
      //console.log('variant:changed',event);
      var variant = event.detail.variant;
      //console.log('variant',variant);
      pdp_checkPurchaseLimit(variant.id);
  });
  document.addEventListener('product:added', function(event) {
  	var variant = event.detail.variant; // Get the variant that was added
  	var quantity = event.detail.quantity; // Get the quantity that was added
    pdp_checkPurchaseLimit(variant.id, quantity);
  });
  
  // prevent enter key form submission in cart item qty  
  $('#sidebar-cart').on('keydown', '.CartItem .QuantitySelector__CurrentQuantity', function (e) {
      //console.log('keydown', e.keyCode);
      if (e.keyCode == 13) {
          e.preventDefault();
          return false;
      }
  });
  /* END: Purchase Limit code */
  
  
  /* Customizable PDP */
  var initialsInput = $('#custom-initials'); 
  var numberOfLetters = $('.ProductForm__Option--numberofletters');
  function pdp_checkInitials() {
    //console.log('pdp_checkInitials', initialsInput.val().length);
    if (addToCartForm.length && initialsInput.length) {
      if (initialsInput.val().length !== 2) {
    	//addToCartForm.find('button[type="submit"]').prop('disabled', true).addClass('Button--secondary').removeClass('Button--primary').removeAttr('data-action'); //.find('span').text(maxqty + ' per customer');
      } else {
        //addToCartForm.find('button[type="submit"]').prop('disabled', false).removeClass('Button--secondary').addClass('Button--primary').attr('data-action', 'add-to-cart');
      }
    }
  }
  
  if (initialsInput.length) {
    pdp_checkInitials();
    
    $('.Product__Wrapper').on('keyup paste blur change', '#custom-initials', function (e) {
      // don't want to use regex
      var str = this.value;
      var alpha = "abcdefghijklmnopqrstuvwxyz";
      var temp = "";
      for (var i = 0; i < str.length; i++) {
        for (var j = 0; j < alpha.length; j++) {
          if (str[i] === alpha[j] || str[i] === alpha[j].toUpperCase()) {
            temp += str[i];
          }
        }
      }
      this.value = temp.toUpperCase();
      
      if (numberOfLetters.length) {
       //window.console.log('numberOfLetters', temp.length);
       	var popoverId = numberOfLetters.find('button.ProductForm__Item').attr('aria-controls');
        if (popoverId) {
          var numLettersPop = $('#'+popoverId);
          if (numLettersPop.length) {
            var valueButtons = numLettersPop.find('.Popover__Value');
            var theBtn = valueButtons.filter('[data-value="'+temp.length+'"]');
            //window.console.log('theBtn',theBtn);
            theBtn.trigger('click');
          }
        }
        
      }
      
      pdp_checkInitials();
    }).on('keydown', '#custom-initials', function (e) {
        //console.log('keydown', e.keyCode);
        if (e.keyCode == 13) {
            e.preventDefault();
            return false;
        }
    });
  }  
  /* END: Customizable PDP */

  /* GWP / Free Gift with Purchase code */
  /* must also have Buy X (Amount) Get Y (Product) promo discount set up*/
    var cartThresholdInDollars = 100; // edit this amount
  
  function checkGWP() {
    if (window.theme.GWPEnabled && window.theme.gwpVariantId != null) {
      // get the cart details json
      $.getJSON('/cart.json', function(cart) {
        var cartTotalInCents = cart.total_price;
        var cartThresholdInCents = cartThresholdInDollars * 100;
        // check if the user has met the threshold to receive the gift
        if (cartTotalInCents >= cartThresholdInCents) {
          var gwpInCart = cart.items.filter(it => it.variant_id == window.theme.gwpVariantId).length;
          // if the gwp is not already in the cart, add it
          if (gwpInCart == 0) {
            $.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: 'id=' + window.theme.gwpVariantId + '&quantity=1',
              dataType: 'json'
            }).then(function () {
              //window.console.log('free gift added');
              fetch('/cart?view=drawer&timestamp=' + Date.now(), {
                credentials: 'same-origin',
                method: 'GET'
              }).then(function (content) {    
                content.text().then(function (html) {
                   var newDrawerContent = $(html).find('.Drawer__Content');
                  //window.console.log('newDrawerContent', newDrawerContent);
                  $('#sidebar-cart').find('.Drawer__Content').replaceWith(newDrawerContent);
                });
              });        
            });
  
          }
        }  
      });
    }
  }
  
  // check gwp on page load  
  checkGWP();
  
  // check gwp on variant changed
  document.addEventListener('variant:changed', function(event) {
      checkGWP();
  });
  document.addEventListener('product:added', function(event) {
    checkGWP();
  });
  /* END: GWP / Free Gift with Purchase code */

  /* Show other colors on PDP */
  var colorOptionDiv = $('.ProductForm__Option--color');
  if (colorOptionDiv.length) {
    initPDPOtherColors();
  }
  function initPDPOtherColors() {
    //console.log('initPDPOtherColors');
    colorOptionDiv = $('.ProductForm__Option--color');
    var productInfo = colorOptionDiv.closest('.Product__Info');
    var jsonData = JSON.parse(productInfo.find('[data-product-json]').html());
    var productData = jsonData['product'];
    var colorOptionPosition = null;
    for (var k = 0; k < productData.options.length; k++) {
      var option = productData.options[k];
      //console.log('option', option);
      if (option.toLowerCase() == 'color') {
        colorOptionPosition = k;
        break;
      }
    }
    var skuTags = [];
    for (var i = 0; i < productData.tags.length; i++) {
      var tag = productData.tags[i];
      if (tag.indexOf('sku:') == 0) {
        skuTags.push(tag);
        break;
      }
    };
    if (skuTags.length) {
      //console.log('has sku tag', skuTags);
      fetch("/collections/all".concat("/".concat(skuTags[0]), "?view=data"))
      .then((response) => response.json())
      .then((data) => buildColorSwatches(data, colorOptionPosition));
    }
    
  }
  function buildColorSwatches(data, optionPosition) {
    //console.log('buildColorSwatches', data, optionPosition);
    var colorUL = colorOptionDiv.find('.ColorSwatchList');
    var selectedRadio = colorOptionDiv.find('.ColorSwatch__Radio:checked');
    var currentColor = selectedRadio.val();
    //console.log('currentColor', currentColor);
    if (data.products.length > 1) {
      colorOptionDiv.closest('.ProductForm__Variants').prepend(colorOptionDiv);
      colorOptionDiv.removeClass('ProductForm__Option--singlevalue');
    }
    for (var i = 0; i < data.products.length; i++) {
      var prod = data.products[i];

      if (prod.selectedColor == currentColor) {
        selectedRadio.closest('li').attr('data-sort', i);
        selectedRadio.next('label').css('background-image', 'url('+prod.featuredImage+')');
      } else {
        //console.log('new prod', prod.selectedColor);
        var variantsJson = prod.fullJson['variants'];        
        var newRadio = $('<input class="ColorSwatch__Radio" type="radio" />');        
        newRadio.attr('name', 'option-' + optionPosition).attr('id', 'option-' + optionPosition + '-' + (i+1)).attr('value', prod.selectedColor).attr('data-option-position', optionPosition+1);
        newRadio.attr('data-variant-json', JSON.stringify(variantsJson));
        var newLabel = $('<label class="ColorSwatch ColorSwatch--large"></label>');
        newLabel.attr('for', 'option-' + optionPosition + '-' + (i+1)).attr('data-tooltip', prod.selectedColor).attr('data-url', prod.url).css('background-image', 'url('+prod.featuredImage+')');
        var newSpan = $('<span class="u-visually-hidden">' + prod.selectedColor + '</span>');
        newLabel.append(newSpan);
        var newLI = $('<li class="HorizontalList__Item" />');
        newLI.attr('data-sort', i);
        newLI.append(newRadio);
        newLI.append(newLabel);
        colorUL.append(newLI);
      }
    };
    
    colorUL.find('li').sort(function(a, b) {
        //console.log('sort', a.dataset.sort, b.dataset.sort);
        return +a.dataset.sort - +b.dataset.sort;
    }).appendTo(colorUL);
    
    $(document).off('.customcolors').on('click.customcolors', '.ColorSwatch', (event) => {
      const href = event.target.attributes['data-url'].nodeValue
      //console.log('click', href);
      //location.href = href;
      // set up new URL in browser window
      window.history.replaceState({}, '', href)
  
      new Promise(() => {
        refreshProductSections(href)
      }).catch((err) => {
        console.log(err)
      })

    });
  }
  const refreshProductSections = (link) => {
    //console.log('refreshProductSections', link);
    if ($('.js-smp-reload').length > 0) {
      $('.js-smp-reload').each(function (i, item) {
        // get section id
        const sectionId = item.id.replace('shopify-section-', '')
        const newUrl = link + `?section_id=` + sectionId;
        //console.log('get newUrl', newUrl);
  
        window
          .fetch(newUrl)
          .then()
          .then((_) => _.text())
          .then((html) => {
            //console.log('got html for ', sectionId);
            themeSectionContainer._onSectionUnload({ detail: { sectionId: sectionId }});
            const sectionElement = $('#shopify-section-' + sectionId); //.find('[data-section-type=product]')
            sectionElement.replaceWith(html)
            //var newSection = $(html);
            //var sectionContents = newSection.find('[data-section-type=product]').contents();
            //sectionElement.empty().append(sectionContents);
            
          })
          .then((_) => {
            //console.log('re-init');
            // installedModules[43].exports.default is ProductSection in theme.js webpack file
            themeSectionContainer.register('product', installedModules[43].exports.default);
  
            //themeSectionContainer._onSectionLoad({ detail: { sectionId: sectionId }});
            
            initPDPOtherColors();
            //window.themeProduct.reload();
  
          })
      })
    }
  }
  /* END: Show other colors on PDP */
  
})(jQuery);
